import { render } from "./News.vue?vue&type=template&id=bf95b13a&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=bf95b13a&scoped=true&lang=css"
import "./News.vue?vue&type=style&index=1&id=bf95b13a&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf95b13a"]])

export default __exports__